import * as React from 'react';
import { createDocumentUrl } from '../../../cloudinary';
import Layout from '../../../components/Layout';
import styled from '../../../styled-components';
import { Document } from '../types';

interface DocumentsProps {
    documents: Document[];
}

const DocumentTitle = styled.div`
    flex-basis: 1;
    flex-shrink: 0;
`;

const Documents: React.FC<DocumentsProps> = props => {
    const renderDocument = (doc: Document) => (
        <Layout key={doc.id}>
            <DocumentTitle>
                <a href={createDocumentUrl(doc.documentReference)} target="_blank">
                    {doc.documentName}
                </a>
            </DocumentTitle>
        </Layout>
    );

    return <div>{props.documents.map((doc: Document) => renderDocument(doc))}</div>;
};

export default Documents;



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/components/Documents.tsx